import axios from 'axios';


export default {
  login ({ username, password }) {
    return axios.post('/users/login', { username, password })
      .then(response => response.data);
  },
  getUser (id) {
    return axios.get(`/users/${id}`)
      .then(response => response.data);
  },
  checkUsername (username) {
    return axios.get('/users/check-username', { params: { username } })
      .then(response => response.data);
  }
};
